// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import Modal from '../../Modals/Modal';
import Select from 'react-select';

import '../../../styles/journalTo.css';
export default class JournalTo extends Modal {

    state = {
        month: "June", 
        source: "Deposits",
        available: 100, 
        moveAmount: 0, 
    }

    componentDidMount = () => {
        this.setState({
            moveAmount: (this.props.data?.moveAmount??0).toString()
        })
    }

    formatValue = (v) => {
        if(!v) return '';
        const value = typeof v === 'number'? v? v>0? v.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }): `(${(v * -1).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })})`: '-': v;

        return value; 
    }

    renderContent = () => {
        const d = this.props.data ? this.props.data : {};
        return (
            <div
                className="modal-content modal-center"
            >
                <h1>Journal Transactions</h1>
                <p>This feature allows you to record a transaction moving funds from <strong>{this.state.source.toLowerCase()}</strong> to a different category. Use this journal entry to track transfers, or reallocate resources across categories effectively.</p>
                <br /> 
                <div className='journal-to-from-container'>
                        <div
                            className='journal-to-amount'
                        >
                            {this.formatValue(d.available) || "-"}
                        </div>
                        <div
                            className='journal-to-source'
                        >
                            {d.month} {d.source}
                        </div>
                </div>
                <div
                    className='journal-to-transfer-container'
                >
                   
                    <input 
                        className='journal-to-move-amount no-spinners'
                        type='number'
                        value={this.formatValue(this.state.moveAmount)}
                        onChange={(e) => {
                            // Lets do some checks to make sure this is valid.... 
                            let value = e.target.value;  
                            // Make sure value is a string... 
                            value = value.toString(); 

                            // If we have more than 2 decimal places... no can do.
                            if(value.split('.').length > 1 && value.split('.')[1].length > 2) return;

                            this.setState({moveAmount: value});
                        }}
                        placeholder='0.00' 
                    />

                    <div className='journal-to-arrow' />
                    
                    <div className='journal-to-target'>
                        <Select 
                            className="filter-selector-container"
                            classNamePrefix='filter-selector'
                            isMulti={false} 
                            options={[
                                {value: 'deposits', label: 'Deposits'},
                                {value: 'withdrawals', label: 'Withdrawals'},
                                {value: 'income', label: 'Income'},
                                {value: 'fees', label: 'Fees'},
                                {value: 'loanPayments', label: 'Loan Payments'},
                                {value: 'transfers', label: 'Transfers'},
                                {value: 'rollovers', label: 'Rollovers'},
                                {value: 'accrued', label: 'Accrued'},
                                {value: 'purchases', label: 'Purchases'},
                                {value: 'sales', label: 'Sales'},
                                {value: 'reinvestments', label: 'Reinvestments'},
                                {value: "other", label: "Other transactions"}
                            ]}
                            value={this.state.target}
                            onChange={(e) => this.setState({target: e})}
                        />
                    </div>
                </div>
                <input
                    className="import-config-button"
                    style={{
                        marginLeft: 0, 
                        float: 'none',
                        width: 220
                    }}
                    type="submit"
                    value="Confirm"
                    onClick={() => {
                        d.onSave({
                            amount: this.state.moveAmount, 
                            destination: this.state.target?.value,
                            source: this.props.data.source, 
                        }); 
                        this.props.modal("");
                    }}
                />
            </div>
        );
    }
};